import theme from 'src/components/themes/DefaultTheme';
import styled, { css } from 'src/lib/styles/css';


//#region [Styles]
type SSectionTitleProps = {
	$textCenteredMobile?: boolean;
	$textCenteredDesktop?: boolean; // must be explicitly set or it will inherit from mobile
};

const SSectionTitle = styled.h2<SSectionTitleProps>`
	color: var(--textcolor);
	grid-column: 1 / 3;
	margin-bottom: 15px;

    &::first-letter {
        text-transform: capitalize;
    }

	${props => props.$textCenteredMobile ? css`
		text-align: center;
	`: ""}

	@media (min-width: 550px) {
        /*@media (orientation: landscape) {*/
        grid-column: 1 / 7;
        font-size: 28px;

        ${props => props.$textCenteredDesktop === true ? css`
			text-align: center;
		`: ""}
		${props => props.$textCenteredDesktop === false ? css`
			text-align: left;
		`: ""}
	}
`;

export default SSectionTitle;
//#endregion